import { Controller } from "@hotwired/stimulus"
import { debounce } from "lodash"

// Chowa elementy paska narzędzi, które nie mieszczą się w dostępnej szerokości, do dropdownu "Zobacz więcej"
// TODO: list/bulk_controller.js#updateMenu ma zduplikowaną wersję tej logiki na potrzeby paska
// bulk-selection (invoices/products/clients/banking/payments/warehouse_documents index, accounting_office/companies).
// Docelowo przenieść te widoki na ten kontroler i usunąć duplikat — osobny PR.
export default class extends Controller {
  static targets = ["list", "dropdown", "moreBtn"]

  visibleWidth = 0

  connect() {
    this.debouncedUpdateMenu = debounce(this.updateMenu.bind(this), 150)
    window.addEventListener("resize", this.debouncedUpdateMenu)
    this.updateMenu()
  }

  disconnect() {
    window.removeEventListener("resize", this.debouncedUpdateMenu)
    this.debouncedUpdateMenu.cancel()
  }

  updateMenu() {
    const list = this.listTarget
    const dropdown = this.dropdownTarget
    const menuContainerWidth = list.parentElement.offsetWidth

    if (this.visibleWidth === menuContainerWidth) return
    this.visibleWidth = menuContainerWidth

    this.moreBtnTarget.classList.add("hidden")

    Array.from(dropdown.children).forEach((item) => {
      const clone = this.cloneWithEvents(item)
      item.remove()
      list.appendChild(clone)
    })

    let totalWidth = 0
    Array.from(list.children).forEach((item) => { totalWidth += item.offsetWidth })

    if (totalWidth <= menuContainerWidth) return

    this.moreBtnTarget.classList.remove("hidden")
    const limit = menuContainerWidth - this.moreBtnTarget.offsetWidth

    let used = 0
    Array.from(list.children).forEach((item) => {
      used += item.offsetWidth
      if (used > limit) {
        const clone = this.cloneWithEvents(item)
        item.remove()
        dropdown.appendChild(clone)
      }
    })
  }

  cloneWithEvents(src, events = ["onclick", "onmouseover"]) {
    const clone = src.cloneNode(true)

    function copyEvents(origEl, cloneEl) {
      events.forEach(ev => {
        if (origEl[ev]) cloneEl[ev] = origEl[ev]
      })

      Array.from(origEl.children).forEach((child, i) => {
        copyEvents(child, cloneEl.children[i])
      })
    }

    copyEvents(src, clone)
    return clone
  }
}
